import { render } from "./MyStats.vue?vue&type=template&id=1e9eb395"
import script from "./MyStats.vue?vue&type=script&lang=js"
export * from "./MyStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__